/* eslint-disable @typescript-eslint/naming-convention */
import { AssistantCategoryTypes } from '@utils/enums/assistant-types';
import { post, get, ResponseWithData, StandardResponse } from '.';

type SetAiAssistantSessionResponse = StandardResponse<{
  message: string;
}>;

type GetAiAssistantSessionResponse = {
  history: Array<{
    type: string;
    content: string;
  }>;
  session_id: string;
  created_at: string;
};

type SendMessageResponse = {
  content: string;
  session_id: string;
};

export async function postChatAssistant({
  input,
  sessionId,
  assistantCategory,
  additionalContext
}: {
  input: string;
  sessionId: string;
  assistantCategory: AssistantCategoryTypes;
  additionalContext: string;
}): Promise<SendMessageResponse> {
  const body = {
    input,
    sessionId,
    assistantCategory,
    additionalContext
  };

  const { data } = await post<SendMessageResponse>(
    '/api/ai-assistant/chat',
    body
  );

  console.log(data);

  return data;
}

export async function getHistoryMessage({
  sessionId,
  assistantCategory
}: {
  sessionId: string;
  assistantCategory: AssistantCategoryTypes;
}): Promise<GetAiAssistantSessionResponse> {
  const { data } = await get<GetAiAssistantSessionResponse>(
    `/api/ai-assistant/history/${assistantCategory}/${sessionId}`
  );

  return data;
}

export async function clearHistoryAiAssistantSession({
  sessionId,
  assistantCategory
}: {
  sessionId: string;
  assistantCategory: AssistantCategoryTypes;
}): Promise<GetAiAssistantSessionResponse> {
  const { data } = await post<GetAiAssistantSessionResponse>(
    `/api/ai-assistant/clear-history/${assistantCategory}/${sessionId}`,
    {}
  );

  return data;
}

export async function setAiAssistantSession({
  exerciseId,
  sessionId
}: {
  exerciseId: string;
  sessionId: string;
}): Promise<ResponseWithData<SetAiAssistantSessionResponse>> {
  const body = {
    exerciseId,
    session_id: sessionId
  };

  const responseWithData: Promise<
    ResponseWithData<SetAiAssistantSessionResponse>
  > = post('/api/ai-assistant/set-session', body);

  return (await responseWithData) as {
    response: Response;
    data: SetAiAssistantSessionResponse;
  };
}
